import is from '@sindresorhus/is';
import { useCallback } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import type { ProfileForm } from '../types';

// Scrolls the first skill missing a proficiency level into view. Skills expose their id via the
// `data-skill-id` attribute (see SkillList), which is how we locate the element after a failed save.
export const useScrollToInvalidSkill = (formMethods: UseFormReturn<ProfileForm>): (() => void) => {
    return useCallback(() => {
        const firstInvalidSkill = formMethods
            .getValues('competencies')
            .flatMap((competency) => competency.skills)
            .find((skill) => !is.number(skill.level));

        if (is.undefined(firstInvalidSkill)) {
            return;
        }

        requestAnimationFrame(() => {
            const element = document.querySelector<HTMLElement>(
                `[data-skill-id="${CSS.escape(firstInvalidSkill.id)}"]`,
            );
            element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }, [formMethods]);
};
